import { Skeleton } from "@radix-ui/themes";

interface LoadingCellProps {
  index?: number;
}

export function LoadingCell({ index = 0 }: LoadingCellProps) {
  const random = Math.round(Math.random() * 20) + 10;

  return (
    <Skeleton
      loading
      width={`calc(100% - ${random}%)`}
      maxWidth={`calc(240px - ${random}px)`}
      height={"20px"}
      style={{
        opacity: Math.max(index < 5 ? 1 : 1 - 0.15 * (index - 4), 0.15),
      }}
    />
  );
}
